import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

export const ProductCardWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  position: relative;
  font-family: "Lato", sans-serif;
  border-radius: 6px;
  cursor: pointer;
  transform-origin: center;
  transition: transform 0.2s linear, box-shadow 0.2s linear;
  /* overflow: hidden; */
  &:hover {
      //box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    transform: scale(1.025);
  }
  
  h3.product-title {
    display: block;
    font-weight: 600;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: pre-wrap;
  }
`;

export const ProductPriceWrapper = styled.div`
  width: fit-content;
  display: flex;
  column-gap: 0.35rem;
  flex-wrap: wrap;
`;

export const ProductPrice = styled.div`
  font-family: "Lato", sans-serif;
  font-size: 1.125rem;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.primary", "#9cc54b")};

  &.express {
    color: #f01266 !important;
  }

  // &.strike-through{
  //   color: ${themeGet("color.warning", "#ffc107")} !important;
  // }

  // &.promo-price {
  //   color: #ffc107 !important;
  // }

    
  @media only screen and (max-width: 667px){
    font-size: 1rem;
  }
`;

export const PromoPrice = styled.div`
  font-family: "Lato", sans-serif;
  font-size: 1.125rem;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: #ffc107 !important;

  .promo-price {
    color: #ffc107 !important;
  }

  @media only screen and (max-width: 667px){
    font-size: 1rem !important;
  }
`;

export const SalePrice = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "13")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.yellow", "#FBB979")};
  font-style: italic;
  overflow: hidden;
  position: relative;

  &:before {
    content: "";
    width: 100%;
    height: 1px;
    display: inline-block;
    background-color: ${themeGet("colors.yellow", "#FBB979")};
    position: absolute;
    top: 50%;
    left: 0;
  }
`;

export const ProductImageWrapper = styled.div`
  width: 100%;
  min-height: 210px;
  padding: 0px 5px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .product-image{
    width: auto;
    max-width: 165px;
    height: 100%;
    // min-height: 100px;
    max-height: 165px;
  }

  .ribbon {
    text-transform: uppercase;
    color: white;
  }
  .ribbon3 {
    font-size: 11px;
    width: 100%;
    max-width: 80px;
    height: 23px;
    line-height: 23px;
    padding-left: 0px;
    position: absolute;
    left: -8px;
    top: 20px;
    background: #9cc54b;
    z-index: 2;
    
    &.full-width {
      height: 23px;
      max-width: 110px;
      background: #f78205;
      
      span.ribbon3-duplicate {
        height: 0;
        width: 0;
        right: -10.5px;
        top: 0;
        border-top: 12px solid #f78205;
        border-bottom: 11px solid #f78205;
        border-left: 0px solid #f78205;
        border-right: 11px solid transparent;
        position: absolute;
      }
      &:after {
        border-top: 12px solid #f78205;
        border-bottom: 11px solid #f78205;
        border-left: 0px solid #f78205;
      }
    }
  }
  &.express span.ribbon3 {
    background: #f01267;
    
    &.full-width span.ribbon3-duplicate {
      border-top: 12px solid #f78205;
      border-bottom: 11px solid #f78205;
      border-left: 0px solid #f78205;
    }
    
    &:after {
      border-top: 12px solid #f01267;
      border-bottom: 11px solid #f01267;
      border-left: 0px solid #f01267;
    }
  }
  
  .ribbon3:before,
  .ribbon3:after {
    content: "";
    position: absolute;
  }
  .ribbon3:before {
    height: 0;
    width: 0;
    bottom: -8.5px;
    left: 0.1px;
    border-top: 9px solid black;
    border-left: 9px solid transparent;
  }
  .ribbon3:after {
    height: 0;
    width: 0;
    right: -10.5px;
    border-top: 12px solid #9cc54b;
    border-bottom: 11px solid #9cc54b;
    border-left: 0px solid #9cc54b;
    border-right: 11px solid transparent;
  }
  .ribbon4 {
    font-size: 11px;
    width: 80px;
    height: 23px;
    line-height: 23px;
    padding-left: 0px;
    position: absolute;
    left: -8px;
    top: 50px;
    background: #FF0000;

  }
  .ribbon4.custom {
    top: 20px;
  }
  .ribbon4:before,
  .ribbon4:after {
    content: "";
    position: absolute;
  }
  
  .ribbon4:before {
    height: 0;
    width: 0;
    bottom: -8.5px;
    left: 0.1px;
    border-top: 9px solid black;
    border-left: 9px solid transparent;
  }
  
  .ribbon4:after {
    height: 0;
    width: 0;
    right: -10.5px;
    border-top: 12px solid #FF0000;
    border-bottom: 11px solid #FF0000;
    border-left: 0px solid #9cc54b;
    border-right: 11px solid transparent;
  }
  @media (max-width: 1400px) {
    .product-image{
      max-width: 200px;
    }
  }
  @media (max-width: 767px) {
    .product-image{
      // height: 125px;
      width: auto;
      max-height: 125px;
    }
    .promo-image{
      height: 200px;
      width: auto;
      max-height: 200px;
      min-height: 200px;
    }
    .bigloader {
      background-color: white;
      position: absolute;
      top: calc(100% - 72px);
      right: calc(100% - 95px);
      z-index: 1000;
    }
    .loaderStyle {
      position: absolute;
      top: calc(100% - 115px);
      right: calc(100% - 120px);
      z-index: 1000;
    }
  }

  @media (max-width: 612px){
    padding-top: 100%;
    .ribbon .product-image-wrapper{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      max-width: 100%;
      height: 100%;
      max-height: 100%;  
      display: flex;
      justify-content: center;
      align-items: center;    
    }
    .product-image {
      width: auto;
      max-height: 200px;
      max-width: 200px;
    }
  }

  @media(max-width: 425px){
    padding-top: 100%;

    .ribbon .product-image-wrapper{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      max-width: 100%;
      height: 100%;
      max-height: 100%;  
      display: flex;
      justify-content: center;
      align-items: center;    
    }
    .product-image{
      display: block !important;
      width: auto;
      height: auto;
      max-width: 180px;
      max-height: 180px;
    }
    .loaderStyle {
      position: absolute;
      top: calc(50%);
      right: calc(50%);
      z-index: 1000;
    }
  }
    @media (max-width: 450px) {
    .product-image{
      display: block !important;
      width: auto;
      height: auto;
        max-width: 140px;
        max-height: 140px;
    }
  }
`;

export const DiscountPercent = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "13")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: #ffffff;
  line-height: 24px;
  background-color: ${themeGet("colors.yellow", "#FFAD5E")};
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
  display: inline-block;
  position: absolute;
  top: 15px;
  right: 15px;
  border-radius: 12px;
  z-index: 2;
`;

export const ProductInfo = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  // padding: 10px 15px 10px;
  width: 100%;
  padding: 0.5em;

  @media (max-width: 767px) {
    padding: 0.5rem;
    // min-height: 170px;
  }

  .product-title {
    font-family: "Lato", sans-serif;
    color: ${themeGet("colors.darkBold", "#0D1136")};
    display: block;
    line-height: 1.5;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
    overflow: hidden;
    width: 100%;
    max-width: 280px;
    height: fit-content;
    min-height: 45px;

    @media (max-width: 767px) {
      font-size: 14px;
      margin: 0 0 -5px 0;
    }
  }
		

  .product-weight {
    margin-top: 0;
    font-family: "Lato", sans-serif;
    font-size: ${themeGet("fontSizes.1", "13")}px;
    font-weight: ${themeGet("fontWeights.3", "400")};
    color: ${themeGet("colors.darkRegular", "#77798c")};

    @media (max-width: 767px) {
      font-size: 12px;
    }
  }

  .promo-weight {
    font-size: 21px;
    @media (max-width: 767px) {
      font-size: 17px;
    }
  }

  .product-meta {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-direction: column;
    gap: 0.5rem;

    .product-body {
      width: 100%;
      display: flex;

      .product-country-and-weight {
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        align-items: end;
        justify-content: space-between;
        gap: 0.25rem;

        .product-country {
          span {
            display: inline-block;
          }
        }
      }
    }
    .product-footer {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      // gap: 0.5rem;
    }
  
    &.express span[itemprop="price"] { color: #f01266; }
    }
`;

export const ProductButtons = styled.div`
  flex-wrap: nowrap;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  column-gap: 0.5rem;

  .btn-outline-success,
  .btn-outline-express,
  .wishlist-btn {
    box-sizing: border-box;
    display: grid;
    place-content: center;
    transition: all 0.3s ease;
    outline: none;
    border: none;
    box-shadow: none;
    transition: all 0.2s ease;

    &:focus {
      box-shadow: none !important;
    }
  }

  .btn-outline-success,
  .btn-outline-express  {
    // width: 3.25rem;
    height: 2rem;
    background: #9cc54b;
    color: #ffffff;
    // border-radius: 2rem;
    border: 1px solid #9cc54b;

    width: 100%;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border-radius: 5px;


    &:hover {
      background: transparent !important;
      color: #9cc54b;
      .cart-icon{
        fill: #9cc54b;
      }
      .cart-icon.express{
        fill: #f01266;
      }

    }
  }
  

  &.express {
    background: #f01266 !important;
    color: #ffffff !important;
    border-color: #f01266 !important;
    }
  

  &.express {
    background: #f01266 !important;
    color: #ffffff !important;
    border-color: #f01266 !important;
  }

  .btn-outline-express {
    border: 1px solid #f01266;
    background: #f01266;
    color: #ffffff;

    &:hover{
      color: #f01266;
    }
  }

  .wishlist-btn {
    height: 2.15rem;
    width: 2rem !important;
    background: transparent;
    color: #707070;

    &:focus {
      background: transparent !important;
    }

    .library-icon  {
      font-size: 2rem !important;

      @media (max-width: 490px){
          font-size: 1.75rem !important;
        }
      }
    }
  .cart-icon {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    fill: #fff;
  }
  .cart-icon svg {
    width: 100%;
    height: 100%;
  }
  .cart-buy {
    font-size: 14px;
    font-weight: 700;
    padding-left: 5px;
  }

    .promo-price {
        font-size: 13px;
    }
`;

export const Price = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")} px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.primary", "#9cc54b")};

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

export const Category = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "13")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798c")};
`;

export const BrandLogoWrapper = styled.div`
  height: 54px;
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 10px;
  border-radius: 50%;
  border: 1px solid rgb(236,236,236);
  img {
    display: inline-block;
    height: 52px;
    width: 52px;
    border-radius: 50%;
    object-fit: contain;
  }
`;

export const FavoriteContainer = styled.div`
    background-color: #8080801c;
    display: flex;
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    // padding: 5px;
    margin-left: 10px;
     svg {
       fill: #9cc54b;
       height: 18px;
       width: 18px;
     }
    .btn-favorite {
      z-index: 9;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      display: grid;
      place-content: center;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0;
  
      .favorite-icon,
      .favorites-spinner  {
        color: #9cc54b;
      }
      
      &.express {
        .favorite-icon,
        .favorites-spinner {
          color: #f01266;
        }
      }
    }

  &.product-info {
    // margin-top: 10px;
    width: 35px;
    height: 35px;
    min-width: 35px;
    min-height: 35px;
    background-color: transparent;
  }

  &.express .favorite-icon {
    color: #F01266;
  }
`
